var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isAvatar)?_c('img',{staticClass:"no-avatar",staticStyle:{"width":"35px","height":"35px"},attrs:{"src":require("@/assets/svg/user.svg")}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }